import { Content } from '../../types';

export const maiChauContent: Content = {
  title: "מאי צ'או – חוויית טבע ותרבות בצפון וייטנאם",
  imageUrl: '/images/vietnam/mai-chau/mai-chau-wide.jpeg',
  introduction:
    "מאי צ'או הינו מחוז כפרי קסום בצפון וייטנאם, השוכן כ-140 ק\"מ מערבית להאנוי. זהו אזור הררי עם נופים עוצרי נשימה של עמקים רחבי ידיים, שדות אורז ירוקים וכפרים מסורתיים המאוכלסים על ידי קבוצות אתניות מקומיות, בעיקר בני שבט הטאי הלבן. העיירה מאי צ'או הינה בירת המחוז ומשמשת כבסיס אידיאלי לטיולים בסביבה.",
  sections: [
    {
      title: "איך להגיע למאי צ'או?",
      type: 'text',
      content:
        "הדרך הנוחה ביותר להגיע למאי צ'או הינה באמצעות רכב פרטי או אוטובוס היוצא מהאנוי. הנסיעה נמשכת כ-3.5–4 שעות וכוללת נופים מרהיבים של ההרים והעמקים. מומלץ לעצור בדרך בנקודות התצפית Thung Khe Pass ו-Viewpoint Mai Chau, המספקות נופים פנורמיים של האזור.",
    },
    {
      title: "אטרקציות מרכזיות במאי צ'או",
      type: 'list',
      content: [
        {
          subtitle: 'טיולי אופניים ושדות האורז',
          text: "אחת הפעילויות הפופולריות ביותר במאי צ'או הינה טיול אופניים בין שדות האורז והכפרים המקומיים. ניתן לשכור אופניים בעיירה ולטייל בין הכפרים Pom Coong ו-Lac, שם ניתן לפגוש מקומיים, לצפות בעבודות מלאכה מסורתיות, ולחוות את אורח החיים הכפרי האותנטי.",
        },
        {
          subtitle: 'מפלים ומעיינות חמים',
          text: 'Go Lao Waterfall – מפל ציורי השוכן במרחק נסיעה קצר מהעיירה, מוקף בצמחייה טרופית ומספק הזדמנות לרחצה ורגיעה בטבע.\n\nTat Nang Waterfall – מפל נוסף, גבוה ומרשים יותר, שמציע חוויית טבע פראית.\n\nSuối Nước Nóng Bò Ấm – מעיינות חמים טבעיים, שבהם ניתן ליהנות מטבילה במים חמימים תוך כדי צפייה בנופי ההרים מסביב.',
        },
        {
          subtitle: 'מערת Chieu',
          text: 'מערה מרשימה הנמצאת על צלע הר ומשקיפה על כל העמק. כדי להגיע אליה יש לטפס כ-1,200 מדרגות, אך הנוף המרהיב שמתגלה בסיום הופך את המאמץ למשתלם. פנים המערה מכוסה בנטיפים וזקיפים מרהיבים.',
        },
        {
          subtitle: 'הופעות ריקוד ומוזיקה מסורתית',
          text: 'בכפרים ניתן לחוות מופעי ריקוד מסורתיים של בני שבט הטאי הלבן, הכוללים שירים עתיקים, תלבושות ססגוניות וריקוד הבמבוק המפורסם. חוויית התרבות הזו מעניקה הצצה לאורח החיים הייחודי של המקומיים',
        },
        {
          subtitle: 'שוק מקומי ומלאכות יד',
          text: "במאי צ'או מתקיימים שווקים קטנים שבהם אפשר לרכוש עבודות יד מסורתיות כמו אריגים צבעוניים, כלי קש ועבודות עץ מגולפות. שוק לילה קטן נפתח בעיירה, שם ניתן ליהנות גם ממטעמים מקומיים.",
        },
      ],
    },
    {
      title: "לינה במאי צ'או",
      type: 'list',
      content: [
        {
          subtitle: 'Mai Chau Ecolodge',
          text: "לודג' יוקרתי עם נוף מדהים לשדות האורז, הכולל בריכה ואווירה שקטה.",
        },
        {
          subtitle: 'Mai Chau Valley View Hotel',
          text: 'מלון נעים עם חדרים נוחים ומיקום מרכזי בעיירה.',
        },
        {
          subtitle: 'Homestay בכפרים המקומיים',
          text: 'חוויה אותנטית הכוללת לינה בבית משפחה מקומית, ארוחות ביתיות והתנסות באורח החיים המקומי.',
        },
      ],
    },
    {
      title: 'מתי כדאי לבקר?',
      type: 'text',
      content:
        "הזמן המומלץ ביותר לביקור במאי צ'או הוא בחודשי האביב (מרץ-מאי) והסתיו (ספטמבר-נובמבר), כאשר מזג האוויר נעים ושדות האורז בשיאם. הקיץ עלול להיות חם ולח, בעוד שבחורף הטמפרטורות עלולות להיות קרות מאוד, אך הנוף עדיין קסום.",
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        "בשורה התחתונה, מאי צ'או הינו יעד מושלם למחפשים חוויית טבע אותנטית, אווירה כפרית ונופים מרהיבים. האזור מציע שילוב בין תרבות מסורתית, פעילויות חוץ ונופים עוצרי נשימה, מה שהופך אותו למקום אידיאלי לטיול שקט ומרגיע מחוץ להמולת הערים הגדולות של וייטנאם.",
    },
  ],
};
